import { useGetCourseQuery } from "@/entities/course";
import type { Course } from "@/entities/course";

/**
 * Хук для получения данных курса через RTK Query
 * @returns Данные курса или undefined
 */
export const useCourse = (): Course | undefined => {
  const { data: course } = useGetCourseQuery();
  return course;
};
